import { getDocs, collection } from "@firebase/firestore";
import { firestore } from "../firebase_setup/firebase";

const getCarrers = async (num) => {
  const ref = collection(firestore, "carrers"); // Firebase creates this automatically
  const docs = await getDocs(ref);

  const allCarrers = docs.docs.map(doc => ({ id: doc.id, ...doc.data() }));

  console.log(allCarrers.length);

  const randomCarrers = [];
  const carrersIds = docs.docs.map(doc => doc.id);

  for (let i = 0; i < num && i < allCarrers.length; i++) {
    const randomIndex = Math.floor(Math.random() * allCarrers.length);
    randomCarrers.push(allCarrers.splice(randomIndex, 1)[0]);
  }

  return [randomCarrers, carrersIds];

};

export default getCarrers;
